import { render, staticRenderFns } from "./DecommissionedDevicesTable.vue?vue&type=template&id=99843766&scoped=true"
import script from "./DecommissionedDevicesTable.vue?vue&type=script&lang=js"
export * from "./DecommissionedDevicesTable.vue?vue&type=script&lang=js"
import style0 from "./DecommissionedDevicesTable.vue?vue&type=style&index=0&id=99843766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99843766",
  null
  
)

/* custom blocks */
import block0 from "./DecommissionedDevicesTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports